export default "__VITE_ASSET__1c77ab18__"